import { useState } from 'react'

import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'

import Icon from '@space-core/components/icon'
import Popover from '@space-core/components/popover'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const CustomPopover = styled(Popover)`
  top: 0.3125rem;
  left: -0.5rem;
  --popover-max-width: 18rem;
  --popover-width: 18rem;
  --white: var(--bg-primary);
`

type UnavailableMessageButtonProps = {
  className?: string
}

const UnavailableMessageButton = ({ className }: UnavailableMessageButtonProps) => {
  const { t } = useTranslation()
  const [showMessage, setMessage] = useState<boolean>(false)

  const handleClick = () => {
    setMessage((state) => !state)
  }

  return (
    <div className={className}>
      <button
        className='_text-gray-700 _bg-transparent _border-0 _cursor-pointer _p-0'
        onClick={handleClick}
        data-test='unavailableMessageButton'>
        <Icon icon={faCircleInfo} />
      </button>
      {showMessage && (
        <CustomPopover position='bottom' autoShow>
          <Popover.Body className='_d-flex _justify-content-between _align-items-center _bg-primary _text-gray-700'>
            <span>{t('view_as.unavailable_message')}</span>
            <button
              className='_text-gray-700 _align-self-baseline _border-0 _line-height-sm _cursor-pointer _bg-transparent _flex-shrink-0'
              onClick={handleClick}
              data-test='unavailableMessageCloseButton'>
              <Icon icon={faXmark} />
            </button>
          </Popover.Body>
        </CustomPopover>
      )}
    </div>
  )
}

export default UnavailableMessageButton
